import { XeroAccountMappingOptionDTO } from "@gymflow/types";

export const mapToSelectOptions = (list?: XeroAccountMappingOptionDTO[]) =>
  list?.map((item) => ({
    id: item.id,
    label: item.name,
    value: item.id,
  })) || [];
